import API from '../../api';

const ROOT = '/v1/combat-pro/inventory';

export async function fetchInventory(campaignId, playerId) {
  const response = await API.get(ROOT + '/inventory', { params: { campaign_id: campaignId, player_id: playerId } });
  return response.data;
}

export async function transitionInventoryItem(itemId, payload) {
  const response = await API.post(ROOT + '/items/' + encodeURIComponent(itemId) + '/transition', payload);
  return response.data;
}

export async function activateInventoryItem(itemId, payload) {
  const response = await API.post(ROOT + '/items/' + encodeURIComponent(itemId) + '/activate', payload);
  return response.data;
}

export async function transferInventoryCurrency(payload) {
  const response = await API.post(ROOT + '/currency/transfer', payload);
  return response.data;
}
